// Azura — Fixierter Mini-Warenkorb-Button. Öffnet den bestehenden
// cart-drawer und hält Anzahl/Sichtbarkeit über das cartUpdate-PubSub-Event
// aktuell (ein kurzer /cart.js-Fetch liefert die verlässliche Gesamtzahl,
// da /cart/add.js selbst keinen item_count zurückgibt).
class StickyCartButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.countEl = this.querySelector('.azura-sticky-cart__count');

    this.button.addEventListener('click', () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.open(this.button);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh.bind(this));
    }
  }

  refresh() {
    const cartUrl = window.routes?.cart_url || '/cart';
    fetch(`${cartUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        this.countEl.textContent = cart.item_count;
        this.classList.toggle('is-hidden', cart.item_count === 0);
      })
      .catch((e) => console.error(e));
  }
}

customElements.define('sticky-cart-button', StickyCartButton);
